// extracted by css-extract-rspack-plugin
module.exports =  {"cardHeader":"CollaboratorsCard__cardHeader___G65Tl"};